
import ProductListItem from '@/components/ProductListItem'
import VehicleHeadlightExclusionButton from '@/components/VehicleHeadlightExclusionButton.vue'

export default {
  name: 'VehicleHeadlightExcludedProducts',
  components: {
    ProductListItem,
    VehicleHeadlightExclusionButton,
  },
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
    gridClass: {
      type: String,
      default: 'sm:tw-grid-cols-4 tw-grid-cols-1 sm:tw-gap-2.5',
    },
    products: {
      type: Array,
      default: () => [],
    },
    pendingId: {
      type: [Number, String],
      default: null,
    },
    failedId: {
      type: [Number, String],
      default: null,
    },
  },
}
